import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav>
      <div id="navLeft">
        <span className="navTitle">SaveForLater</span>
      </div>
      <div id="navRight">
        <Link to="/" className="navLink">Home</Link>
        <Link to="/demo" className="navLink">Demo</Link>
        <Link to="/about" className="navLink">About</Link>
      </div>
    </nav>
  );
};

export default Navbar;